// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { scheduleReminderModalStyles } from "@eisinc/Overrides/Components/ScheduleReminderModal";
import { modalButtonsActionStyles, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

scheduleReminderModalStyles.modal = {};

scheduleReminderModalStyles.middleRowLeftColumnGridItem = { width: 12 };

scheduleReminderModalStyles.middleRowRightColumnGridItem = { width: 12 };

scheduleReminderModalStyles.buttonsContainer = {
    ...modalButtonsActionStyles.buttonsGridItem,
    gap: 20,
};

scheduleReminderModalStyles.cancelButtonsGridItem = {
    width: 12,
    css: css`
        ${modalButtonsActionStyles.buttonsGridItem?.css}
    `,
};

scheduleReminderModalStyles.cancelButton =
    scheduleReminderModalStyles.dismissCancelButton =
    scheduleReminderModalStyles.stopButton =
        {
            ...modalButtonsActionStyles.cancelButton,
        };

scheduleReminderModalStyles.scheduleButton = scheduleReminderModalStyles.confirmCancelButton = {
    ...modalButtonsActionStyles.submitButton,
};

scheduleReminderModalStyles.weeklyRadio = scheduleReminderModalStyles.monthlyRadio = {};

scheduleReminderModalStyles.cancelAndSubmitButtonsGridItem = {
    css: css`
        flex-direction: row;
        gap: 20px;
        justify-content: space-between;
        ${({ schedule }: any) =>
            schedule &&
            css`
                justify-content: flex-end;
                ${xScreen("lte", "sm")} {
                    justify-content: space-between;
                }
            `}
    `,
};

scheduleReminderModalStyles.stopButtonGridItem = { width: [12, 12, 6, 6, 6] };
